import React, { useState } from "react";

import { MagnifierIcon } from "@/assets/icons";
import { TextInput } from "@/components/ui/formControls";
import { cn } from "@/lib/cn";

interface SearchInputProps {
  id: string;
  className?: string;
  label: string;
  labelVisible?: boolean;
  placeholder?: string;
  value?: string;
  onChange: (value?: string) => void;
  onBlur?: (value?: string) => void;
}
export const SearchInput = (props: SearchInputProps) => {
  const { className, value, onChange, placeholder, ...other } = props;
  const [val, setValue] = useState<string | undefined>(value);

  const handleChange = (_value?: string) => {
    setValue(_value);
    onChange(_value);
  };

  return (
    <div className={cn("relative", className)}>
      <TextInput
        {...other}
        autoComplete="off"
        // Password managers ignore autocomplete="off" and guess login fields from the label and
        // placeholder, so a search mentioning "email" gets covered by their suggestions. These
        // flags only reach browser extensions: Chrome's own address autofill ignores them and
        // autocomplete="off" alike, so keep "email" out of the label and placeholder too.
        data-lpignore="true"
        data-1p-ignore
        data-bwignore
        data-form-type="other"
        clearable={true}
        value={val}
        placeholder={placeholder || "Type search phrase..."}
        onChange={handleChange}
        // Room on the right for the magnifier, with the clear button beside it
        className="[&_button]:right-8 [&_input]:pl-4 [&_input]:pr-[30px]"
      />
      <MagnifierIcon className="pointer-events-none absolute bottom-5 right-3 translate-y-1/2 text-muted-foreground" />
    </div>
  );
};
